/* eslint-disable import/no-anonymous-default-export */
import { Alert } from "../components/Alert.components";

import {
  getUsers,
  postUser,
  getUserDetails,
  deleteUser,
  deleteCompany,
  putResetPassword,
  putEditUser,
  getCompanies,
  getDepartments,
  postCompany,
  postDepartment,
  putEditCompany,
  getDirectors,
  postDirector,
  deleteDirector
} from "../services/users";

import { storageUsersModel, storageOrganisation } from "../utils/constant";
import { asyncLocalStorage } from "../utils/utils";

const initialState = {
  usersList: [],
  usersTotal: 0,
  directorsList: [],
  directorsTotal: 0,
  companyList: [],
  companyTotal: 0,
  departmentsList: [],
  departmentsTotal: 0,
  createUserModal: false,
  createDirectorModal: false,
  createCompanyModal: false,
  createDepartmentModal: false,
  deleteUserModal: false,
  deleteDirectorModal: false,
  deleteCompanyModal: false,
  viewUserModal: false,
  resetModal: false,
  userData: {},
  directorData: {},
  singleCompanyData: {},
  usersDetail: {}, // user detail on profile
  activeOrg: {}, // For Account directors
  switchCompanyModal: false,

  rolesList: [],
  rolesTotal: 0,
  roleData: {},
  roleEditMode: false,

  permissionList: [],
};

export default {
  namespace: "users",

  state: {
    ...initialState,
  },

  subscriptions: {
    setup({ dispatch }) {
      // eslint-disable-line
      try {
        let model = localStorage.getItem(storageUsersModel);
        if (model) {
          let data = JSON.parse(model);
          dispatch({
            type: "save",
            payload: data,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },

  effects: {
    *getAllUsers({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getUsers, payload);
      if (success) {
        const list = raw?.users;
        // const total = raw?.users?.length;
        const total = raw?.totalItems;
        yield put({
          type: "save",
          payload: { usersList: list, usersTotal: total },
        });
      } else {
        Alert.error(message);
      }
    },
    *getAllDirectors({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getDirectors, payload);
      console.log({raw});
      if (success) {
        const list = raw?.users;
        // const total = raw?.users?.length;
        const total = raw?.totalItems;
        yield put({
          type: "save",
          payload: { directorsList: list, directorsTotal: total },
        });
      } else {
        Alert.error(message);
      }
    },
    *getAllCompanies({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getCompanies, payload);
      if (success) {
        const list = raw?.tenants;
        const total = raw?.totalItems;
        // const total = raw?.tenants?.length;
        yield put({
          type: "save",
          payload: { companyList: list, companyTotal: total },
        });
      } else {
        Alert.error(message);
      }
    },
    *getAllDepartments({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getDepartments, payload);
      if (success) {
        const list = raw?.departments;
        const total = raw?.totalItems;
        yield put({
          type: "save",
          payload: { departmentsList: list, departmentsTotal: total },
        });
      } else {
        Alert.error(message);
      }
    },
    *getSingleUser({ payload }, { call, put }) {
      yield put({
        type: "save",
        payload: { userData: payload },
      });
    },
    *getSingleDirector({ payload }, { call, put }) {
      yield put({
        type: "save",
        payload: { directorData: payload },
      });
    },
    *getSingleCompany({ payload }, { call, put }) {
      yield put({
        type: "save",
        payload: { singleCompanyData: payload },
      });
    },
    *postCreateUser({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(postUser, payload);
      if (success) {
        const data = raw?.newuser;
        const oldList = yield select(({ users }) => users.usersList);
        const newList = [data, ...oldList];

        yield put({
          type: "save",
          payload: { createUserModal: false, usersList: newList },
        });
        Alert.success("User account is successfully created");
      } else {
        Alert.error(message);
      }
    },
    *postCreateDirector({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(postDirector, payload);
      if (success) {
        const data = raw?.newuser;
        const oldList = yield select(({ users }) => users.directorsList);
        const newList = [data, ...oldList];

        yield put({
          type: "save",
          payload: { createDirectorModal: false, directorsList: newList },
        });
        Alert.success("Director account is successfully created");
      } else {
        Alert.error(message);
      }
    },

    *postCreateCompany({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(postCompany, payload);
      if (success) {
        const data = raw?.newTenant;
        const oldList = yield select(({ users }) => users.companyList);
        const newList = [data, ...oldList];

        yield put({
          type: "save",
          payload: { createCompanyModal: false, companyList: newList },
        });
        Alert.success("Company successfully created");
      } else {
        Alert.error(message);
      }
    },

    *postCreateDepartment({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(postDepartment, payload);
      console.log(raw);
      if (success) {
        const data = raw?.newDepartment;
        const oldList = yield select(({ users }) => users.departmentsList);
        const newList = [data, ...oldList];

        yield put({
          type: "save",
          payload: { createDepartmentModal: false, departmentsList: newList },
        });
        Alert.success("Department successfully created");
      } else {
        Alert.error(message);
      }
    },
    *getUserDetails({ payload }, { call, put }) {
      const { raw, message, success } = yield call(getUserDetails, payload);
      if (success) {
        const data = raw?.data;
        yield put({
          type: "save",
          payload: {
            usersDetail: data,
          },
        });
      } else {
        Alert.error(message);
      }
    },
    *deleteUser({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(deleteUser, payload);
      if (success) {
        const data = raw?.deletedUser;
        const oldList = yield select(({ users }) => users.usersList);
        const newList = oldList.filter((user) => user._id !== data._id);
        yield put({
          type: "save",
          payload: { deleteUserModal: false, usersList: newList },
        });
        Alert.success("User account has been successfully deleted");
      } else {
        Alert.error(message);
      }
    },
    *deleteDirector({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(deleteDirector, payload);
      if (success) {
        const data = raw?.deletedUser;
        const oldList = yield select(({ users }) => users.directorsList);
        const newList = oldList.filter((user) => user._id !== data._id);
        yield put({
          type: "save",
          payload: { deleteDirectorModal: false, directorsList: newList },
        });
        Alert.success("Director account has been successfully deleted");
      } else {
        Alert.error(message);
      }
    },
    *deleteCompany({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(deleteCompany, payload);
      if (success) {
        const data = raw?.deletedOrganization;
        const oldList = yield select(({ users }) => users.companyList);
        const newList = oldList.filter((user) => user._id !== data._id);
        yield put({
          type: "save",
          payload: { deleteCompanyModal: false, companyList: newList },
        });
        Alert.success("Company account has been successfully deleted");
      } else {
        Alert.error(message);
      }
    },
    *editUser({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(putEditUser, payload);
      if (success) {
        const data = raw?.updatedUser;
        const oldList = yield select(({ users }) => users.usersList);
        const newList = [data, ...oldList];

        yield put({
          type: "save",
          payload: { usersList: newList },
        });

        Alert.success("User account has been successfully edited");
      } else {
        Alert.error(message);
      }
    },
    *editCompany({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(putEditCompany, payload);
      console.log(raw);
      if (success) {
        const data = raw;
        const oldList = yield select(({ users }) => users.companyList);
        const newList = [data, ...oldList];

        yield put({
          type: "save",
          payload: { companyList: newList },
        });

        Alert.success("Company profile has been successfully edited");
      } else {
        Alert.error(message);
      }
    },
    *resetPassword({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(putResetPassword, payload);
      if (success) {
        const data = raw?.updatedUser;
        yield put({
          type: "save",
          payload: { resetModal: false },
        });

        Alert.success(`A reset link has been sent to ${data.email}`);
      } else {
        Alert.error(message);
      }
    },
    *switchToCompany({ payload }, { call, put, select }) {
      console.log({ payload });
      yield asyncLocalStorage.setItem(storageOrganisation, payload?._id);
      yield put({
        type: "save",
        payload: { activeOrg: payload, switchCompanyModal: false },
      });
      window.location.reload();
    },
  },

  reducers: {
    save(state, action) {
      const newPayload = {
        ...state,
        ...action.payload,
      };

      try {
        let data = JSON.stringify(newPayload);
        localStorage.setItem(storageUsersModel, data);
      } catch (err) {
        console.log(err);
      }

      return newPayload;
    },
  },
};
